import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { ReactElement, RefObject } from 'react';
import { useRef } from 'react';
import { useChangeTransitionState } from 'util/react-transition-component/hooks/useChangeTransitionState';
import { useTransitionController } from 'util/react-transition-component';
import { ScrollProvider } from 'components/unlisted/ScrollProvider';
import styles from './MenuOverlay.module.scss';
import { setupTransitionInTimeline, setupTransitionOutTimeline } from './MenuOverlay.transitions';
import type { MenuOverlayProps } from './MenuOverlay.data';
import NavigationList from '../navigation-list/NavigationList';
import { useGlobalStore } from '../../../../stores/global';

export default observer(({ className, ref }: MenuOverlayProps): ReactElement => {
  const localRef = useRef(null);
  const elementRef = (ref || localRef) as RefObject<HTMLDivElement | null>;
  const backgroundRef = useRef(null);
  const navigationListRef = useRef(null);
  const { menuIsOpen } = useGlobalStore();

  const transitionController = useTransitionController(
    () => ({
      ref: elementRef,
      refs: {
        elementRef,
        backgroundRef,
        navigationListRef,
      },
      setupTransitionInTimeline,
      setupTransitionOutTimeline,
    }),
    [],
  );

  useChangeTransitionState(transitionController, {
    onMount: false,
    value: menuIsOpen,
  });

  return (
    <div ref={elementRef} className={classNames(styles.menuOverlay, className)}>
      <div ref={backgroundRef} className={classNames(styles.background)} />

      <ScrollProvider wrapperClassName={classNames(styles.scrollBar)} enableSmoothScroll={false}>
        <NavigationList ref={navigationListRef} className={classNames(styles.list)} menu />
      </ScrollProvider>
    </div>
  );
});
